import React, { useEffect, useMemo, useState } from 'react';
import Dashboard from '../../Dashboard';
import MenuContainer from '../../custom-components/menu/MenuContainer';
import AdaptiveContainer from '../../containers/AdaptiveContainer';
import { useNavigate, useParams } from 'react-router-dom';
import { GetKnowledgeData } from '../../../graphql/queries/GetKnowledgeData';
import { useError } from '../../../error-provider/ErrorProvider';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import { Box, Flex, Stack, Textarea, useToast } from '@chakra-ui/react';
import ZaraButton from '../../custom-components/buttons/Button';
import { PATHS } from '../../../router/routes';
import { ChangeKnowledgeDataText } from '../../../graphql/mutations/ChangeKnowledgeDataText';
import { UploadText } from '../../../graphql/mutations/UploadText';
import { getFormatedPath } from '../../../hooks';

const FullTextPage = () => {
    const { agentId, knowledgeId: fullTextId } = useParams();
    const { showError } = useError();
    const router = useNavigate();
    const toast = useToast();

    const isEditText = useMemo(() => {
        return Number(agentId);
    }, [agentId]);

    const { data } = useQuery(GetKnowledgeData, {
        variables: {
            agentId: agentId,
        },
        onError(error) {
            showError(undefined, error);
        },
    });

    const apolloClient = useApolloClient();

    const [value, setValue] = useState('');
    const [knowledgeId, setKnowledgeId] = useState('');
    const [knowledgeData, setKnowledgeData] = useState([]);

    const formatedPath = getFormatedPath(agentId);

    useEffect(() => {
        if (isEditText) {
            const currentKnowledge =
                data?.getKnowledgeData?.knowledgeData?.find((knowledge) => knowledge.id === fullTextId) ?? [];

            setValue(currentKnowledge?.text);
            setKnowledgeId(currentKnowledge.id);
            setKnowledgeData(data?.getKnowledgeData?.knowledgeData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const [changeText, { loading }] = useMutation(ChangeKnowledgeDataText, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const onChangeText = async () => {
        try {
            await changeText({
                variables: {
                    knowledgeDataId: knowledgeId,
                    text: value,
                },
                onCompleted(data) {
                    if (data?.changeKnowledgeDataText?.__typename === 'UploadedKnowledgeDataSuccessType') {
                        toast({
                            title: data?.changeKnowledgeDataText?.message,
                            status: 'success',
                            isClosable: true,
                        });
                        router(formatedPath(PATHS.KNOWLEDGE_BASE));
                    } else {
                        toast({
                            title: data?.changeKnowledgeDataText?.message,
                            status: 'error',
                            isClosable: true,
                        });
                    }
                },
            });
        } catch (error) {
            console.log(error);
        }
    };

    const [uploadText, { loading: textLoading }] = useMutation(UploadText, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const onAddText = async () => {
        await uploadText({
            variables: {
                text: value,
            },
            onCompleted(data) {
                if (data?.uploadText?.__typename === 'UploadedKnowledgeDataSuccessType') {
                    toast({
                        title: data?.uploadText?.message,
                        status: 'success',
                        isClosable: true,
                    });

                    apolloClient.writeQuery({
                        query: GetKnowledgeData,
                        data: {
                            getKnowledgeData: {
                                ...data,
                                knowledgeData: [...knowledgeData, data?.uploadText?.knowledgeData],
                            },
                        },
                    });
                    router(PATHS.KNOWLEDGE_BASE);
                } else {
                    toast({
                        title: data?.uploadText?.message,
                        status: 'error',
                        isClosable: true,
                    });
                }
            },
        });
    };

    const knowledgeText = (
        <Box>
            <Box>
                <Textarea
                    _focus={{ borderColor: 'transparent', boxShadow: 'none' }}
                    onChange={(e) => setValue(e.target.value)}
                    fontSize='16px'
                    lineHeight='20px'
                    fontWeight='400'
                    color='#718096'
                    border='none'
                    value={value}
                    css={{
                        '@media only screen and (min-height: 700px)': {
                            minHeight: '550px',
                        },
                        '@media only screen and (max-height: 700px)': {
                            minHeight: '360px',
                        },
                        '@media only screen and (max-width: 360px)': {
                            minHeight: '420px',
                        },
                    }}
                    p='8px 24px'
                />
            </Box>
            <Flex p='16px 24px' mb='100px' justifyContent='center' alignItems='center'>
                <ZaraButton
                    onClick={(e) => {
                        e.stopPropagation();

                        router(PATHS.KNOWLEDGE_BASE);
                    }}
                    isDisabled={loading || textLoading}
                    variant='secondary'
                    mr='10px'
                >
                    Cancel
                </ZaraButton>
                <ZaraButton
                    isDisabled={!value?.trim()?.length}
                    isLoading={loading || textLoading}
                    onClick={() => {
                        if (isEditText) {
                            onChangeText();
                        } else {
                            onAddText();
                        }
                    }}
                >
                    {isEditText ? 'Update' : 'Add'}
                </ZaraButton>
            </Flex>
        </Box>
    );

    return (
        <Dashboard title='dashboard'>
            <MenuContainer>
                <AdaptiveContainer w='full'>
                    <Stack mt='70px' mb='100px'>
                        {knowledgeText}
                    </Stack>
                </AdaptiveContainer>
            </MenuContainer>
        </Dashboard>
    );
};

export default FullTextPage;
